import { isTrackingParam, trackingParams } from "./listSearchParams";

const BRAND_KEYS = ["marca", "brand", "make"];

function slug(value: string) {
  return value.trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

/**
 * Returns /cars/{brand} when the query holds only one brand (via marca, brand
 * or make), else null. Any other filter keeps the visitor on /cars.
 * Tracking params (utm_*, gclid…) are ignored for the decision and carried
 * over to the target so campaign attribution survives the redirect.
 */
export function brandOnlyTarget(search: Record<string, unknown>): string | null {
  const keys = Object.keys(search).filter(
    (k) => typeof search[k] === "string" && search[k] && !isTrackingParam(k),
  );
  const brandKeys = keys.filter((k) => BRAND_KEYS.includes(k));
  if (brandKeys.length === 0 || brandKeys.length !== keys.length) return null;
  const values = new Set(brandKeys.map((k) => slug(String(search[k]))));
  const [s] = [...values];
  if (values.size !== 1 || !s) return null;
  const tracking = trackingParams(search).toString();
  return `/cars/${s}${tracking ? `?${tracking}` : ""}`;
}
